import(/* webpackMode: "eager" */ "/var/www/vhosts/dailyneedsworld.com/httpdocs/src/app/page.tsx");
